/** Cell `action_identifier` value whose action icon opens the popup menu. */
export const POPUP_MENU_ACTION_IDENTIFIER: string = 'popup_menu';

/**
 * Whether a cell `action_identifier` opens the popup menu (trimmed,
 * case-insensitive).
 */
export function isPopupMenuActionIdentifier(
  actionIdentifier: string | undefined
): boolean {
  return [POPUP_MENU_ACTION_IDENTIFIER].includes(
    actionIdentifier?.trim().toLowerCase() ?? ''
  );
}
